module.exports = __webpack_public_path__ + "images/emoji/maple_leaf.1faeaac627e9d1ee15f1.png";